import { MonthlyChecklistRepository } from "../../repositories/MonthlyChecklistRepository";
import { ChecklistItemEntity } from "../../entities/MonthlyChecklistEntity";

/**
 * Get Checklist Items Use Case (grouped by accounting area)
 */
export class GetChecklistItemsUseCase {
  constructor(private repository: MonthlyChecklistRepository) {}

  async execute(
    checklistId: number
  ): Promise<Record<string, ChecklistItemEntity[]>> {
    return await this.repository.getChecklistItems(checklistId);
  }
}

